import { useDocumentsUploadFile } from '../../../../../../Document'
import { useListingProfileContext } from '../../../RentalPortalListingProfile.hooks'

export function useListingProfileUploadFileAction() {
  const {
    handleCloseModal,
    handleEntityReload,
    handleReloadDocumentsTab,
    listingData,
    setModal,
  } = useListingProfileContext()

  async function handleReload() {
    return Promise.all([handleEntityReload(), handleReloadDocumentsTab()])
  }

  const { getUploadFileInputProps, handleClickUploadFile } =
    useDocumentsUploadFile({
      parent: listingData?.directory_id?.toString(),
      onCloseModal: handleCloseModal,
      onReload: handleReload,
      onSetModal: setModal,
    })

  return {
    getUploadFileInputProps,
    handleClickUploadFile,
  }
}
